import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryDataSource } from '../../api/query';
import type { PanelEkranKaynagi, PanelScreen } from '../../types/panelConfig';

/**
 * Ekran kaynağı YALNIZ ekran sözlüğünden çözülür (`firm_panel_screens.config.kaynaklar`, kalıp:
 * `stok-analiz/ekranKaynaklari.ts`). API rol izni olmayan ds'i sözlüğe yazmaz: `undefined` döner.
 */
export function ekranKaynagi(screen: PanelScreen | undefined, ad: string): PanelEkranKaynagi | undefined {
  return screen?.kaynaklar?.[ad] || undefined;
}

/**
 * ds yalnız BİLDİRDİĞİ parametreyi alır (bildirmediği gönderilirse Postgres 42883). Boş değer de
 * gönderilmez. Anahtar karşılaştırması büyük harfle (`useStokVerisi.bildiriyor` ile aynı kural).
 */
export function raporParametreleri(
  kaynak: PanelEkranKaynagi,
  istenen: Record<string, string | number | null | undefined>,
): Record<string, string> {
  const bildirilen = new Set(kaynak.parameters.map((p) => p.key.toUpperCase()));
  const p: Record<string, string> = {};
  for (const [ad, v] of Object.entries(istenen)) {
    if (v === null || v === undefined || v === '') continue;
    if (bildirilen.has(ad.toUpperCase())) p[ad] = String(v);
  }
  return p;
}

/**
 * Rapor ekranı sorgusu. Parametre değişince ÖNCEKİ veri ekranda kalır (`keepPreviousData`): tarih
 * yazarken ekran boşalmaz, `isFetching` ile "yenileniyor" gösterilir.
 * `success: false` HATA sayılır (jenerik rapor sayfasıyla aynı): boş liste gibi çizilmez.
 */
export function useRaporSorgu<T>(
  kaynak: PanelEkranKaynagi | undefined,
  istenen: Record<string, string | number | null | undefined>,
  enabled = true,
) {
  const parametreler = kaynak ? raporParametreleri(kaynak, istenen) : {};
  return useQuery<T[]>({
    queryKey: ['rapor-ekrani', kaynak?.sourceId, parametreler],
    queryFn: async () => {
      const res = await queryDataSource<T>({ sourceId: kaynak!.sourceId, parameters: parametreler });
      if (!res.success) throw new Error(res.errorMessage ?? 'Sorgu çalıştırılamadı');
      return res.data ?? [];
    },
    enabled: !!kaynak && enabled,
    placeholderData: keepPreviousData,
    throwOnError: false,
  });
}
